module.exports = __webpack_public_path__ + "1d48c3f9066a55c2700cad2ee36130a7.png";